// OfferPromotions.tsx
import * as React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as OfferStore from '../store/Offer';
import * as StockStore from '../store/Stock';
import Select from "./Select";
import DatePicker from "./DatePicker";
import * as Styles from '../styles/baseStyle';
import { getText } from '../utils/texts';
import Moment from 'moment';
import { createSelector } from 'reselect';
import { canUpdate } from '../security/roles';

interface OfferPromotionsOwnProps {
    isDarkMode: boolean;
}

interface OfferPromotionsConnectedProps {
    promotions: any;
    priceNames: any;
    availableProducts: any[];
    itemOfferResult: any;
    itemOfferStates: any;
    disabled: boolean;
    itemOfTheDayState: any;
    promotionDate: any;
    promotionDefaultPriceNameId: any;
    isNewDateSelected: boolean;
    products: any[];
    // Actions
    requestUpdateItemOfTheDay: (timestamp: number, value: any) => void;
    updateNewDateSelected: (value: boolean) => void;
    updateItemPromotionOffer: (storeItemId: any, promotionId: any, date: any, priceNameId: any) => void;
    requestUpdateItemPromotion: (timestamp: number, storeItemId: any, promotionId: any) => void;
    updateCheckedItemOffer: (storeItemId: any, promotionId: any, value: boolean) => void;
    requestCreateItemPromotion: (timestamp: number, storeItemId: any, promotionId: any, priceNameId: any, date: any) => void;
    requestDeleteItemOffer: (timestamp: number, storeItemId: any, promotionId: any) => void;
    resetItemOfferState: (storeItemId: any, promotionId: any) => void;
    updateDateEndItemOffer: (storeItemId: any, promotionId: any, date: any) => void;
    updatePromotionDefaultPriceNameId: (value: any, promotionId: any) => void;
    updatePromotionDate: (date: any) => void;
}

type OfferPromotionsProps = OfferPromotionsOwnProps & OfferPromotionsConnectedProps;

class OfferPromotions extends React.PureComponent<OfferPromotionsProps> {
    get currentItemOfTheDay() {
        return this.props.itemOfferResult?.itemOfTheDay || {};
    }

    get isLoading() {
        return _.values(this.props.itemOfferStates).some(y =>
            _.values(y).some(z => z && z.isLoading)
        ) || this.props.disabled || this.props.itemOfTheDayState.isLoading;
    }

    handleUpdateAll = (promotion: any) => () => {
        this.props.updateNewDateSelected(true);

        _.values(this.props.promotions).forEach(promo => {
            this.props.products.forEach(product => {
                if (this.props.promotionDate || this.props.promotionDefaultPriceNameId[promo.promotionId]) {
                    const itemOffer = this.props.itemOfferResult?.itemPromotions?.[product.storeItemId]
                        ?.find(x => x.promotionId === promo.promotionId);

                    if (itemOffer) {
                        const hasDefaultPrice = product.prices?.some(y =>
                            y.priceNameId === this.props.promotionDefaultPriceNameId[promo.promotionId]
                        );

                        const priceNameId = hasDefaultPrice
                            ? this.props.promotionDefaultPriceNameId[promo.promotionId]
                            : itemOffer.priceNameId;

                        const dateProm = this.props.promotionDate || itemOffer.dateEnd;

                        if (dateProm) {
                            this.props.updateItemPromotionOffer(
                                itemOffer.storeItemId,
                                promo.promotionId,
                                dateProm,
                                priceNameId
                            );
                        }

                        if (promo.promotionId) {
                            this.props.requestUpdateItemPromotion(
                                new Date().getTime(),
                                itemOffer.storeItemId,
                                promo.promotionId
                            );
                        }
                    }
                }
            });
        });
    }

    handleCheckboxChange = (promotion: any) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;

        this.props.products.forEach(product => {
            this.props.updateCheckedItemOffer(product.storeItemId, promotion.promotionId, false);

            const itemOffer = this.props.itemOfferResult?.itemPromotions?.[product.storeItemId]
                ?.find(x => x.promotionId === promotion.promotionId);

            if (checked) {
                this.handleCheckboxChecked(product, promotion, itemOffer);
            } else {
                this.handleCheckboxUnchecked(product, promotion, itemOffer);
            }
        });
    }

    handleCheckboxChecked = (product: any, promotion: any, itemOffer: any) => {
        const hasValidPrice = product.prices && (
            product.prices.some(y => y.priceNameId === this.props.promotionDefaultPriceNameId[promotion.promotionId]) ||
            product.prices.some(y => this.props.priceNames[y.priceNameId]?.name === "Tarif-10") ||
            product.prices.some(y => this.props.priceNames[y.priceNameId]?.name === "TarifPlein")
        );

        if (hasValidPrice) {
            const priceNameId = this.determinePriceNameId(product, promotion);

            if (itemOffer) {
                this.props.requestUpdateItemPromotion(
                    new Date().getTime(),
                    product.storeItemId,
                    promotion.promotionId
                );
            } else {
                const finalPriceId = priceNameId || product.prices[0]?.priceNameId;

                this.props.requestCreateItemPromotion(
                    new Date().getTime(),
                    product.storeItemId,
                    promotion.promotionId,
                    finalPriceId,
                    this.props.promotionDate
                );
            }

            if (this.props.promotionDate && this.props.isNewDateSelected) {
                this.props.updateDateEndItemOffer(
                    product.storeItemId,
                    promotion.promotionId,
                    this.props.promotionDate
                );
            }
        }
    }

    handleCheckboxUnchecked = (product: any, promotion: any, itemOffer: any) => {
        if (itemOffer) {
            this.props.requestDeleteItemOffer(
                new Date().getTime(),
                product.storeItemId,
                promotion.promotionId
            );
        } else {
            this.props.resetItemOfferState(product.storeItemId, promotion.promotionId);
        }
    }

    determinePriceNameId = (product: any, promotion: any) => {
        const defaultPrice = this.props.promotionDefaultPriceNameId[promotion.promotionId];

        if (product.prices?.some(y => y.priceNameId === defaultPrice)) {
            return defaultPrice;
        }

        const tarif10 = product.prices?.find(y =>
            this.props.priceNames[y.priceNameId]?.name === "Tarif-10"
        );
        if (tarif10) return tarif10.priceNameId;

        const tarifPlein = product.prices?.find(y =>
            this.props.priceNames[y.priceNameId]?.name === "TarifPlein"
        );
        return tarifPlein?.priceNameId;
    }

    render() {
        const bgColor = this.props.isDarkMode ? "#181F3A" : "#FFFFFF";
        const isLoading = this.isLoading;
        const priceOptions = [
            { label: "------", value: undefined },
            ..._.values(this.props.priceNames).map(x => ({
                label: x.name,
                value: x.priceNameId
            }))
        ];

        return (
            <div className="selectors borderSelectors">
                <div style={{ display: 'flex', fontSize: 12, margin: '1% 1%' }}>
                    {/* Product of the day */}
                    <div className="card" style={{
                        ...Styles.cardStyle,
                        textAlign: "center",
                        minHeight: 80,
                        width: '50%',
                        margin: "0px 1px"
                    }}>
                        <div style={{ padding: 20 }}>
                            <div style={Styles.filterLabelStyle}>
                                {getText("OfferProductDay")}
                            </div>
                            <div style={{
                                ...Styles.filterControlStyle,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                height: '80%',
                                fontSize: 12
                            }}>
                                <Select
                                    options={this.props.availableProducts}
                                    value={this.currentItemOfTheDay.storeItemId}
                                    disabled={isLoading}
                                    onChange={(value) => this.props.requestUpdateItemOfTheDay(
                                        new Date().getTime(),
                                        value
                                    )}
                                    style={{ background: bgColor }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Promotions section */}
                    <div className="card" style={{
                        ...Styles.cardStyle,
                        textAlign: "center",
                        minHeight: 80,
                        width: '50%',
                        margin: "0px 1px"
                    }}>
                        <div style={{ padding: '10px 2px' }}>
                            <div style={{ marginTop: '1%' }}>
                                {_.values(this.props.promotions).map(x => (
                                    <div key={x.promotionId}>
                                        <div style={{ display: "flex", alignItems: 'center', marginBottom: "1%" }}>
                                            <div style={Styles.filterLabelStyle}>{x.name}</div>
                                            <div className="col-md-6" style={{ width: '-webkit-fill-available', padding: 0 }}>
                                                <button
                                                    className="btn btn-primary"
                                                    style={{ fontSize: 12, fontWeight: 'bold', width: 150, height: 40, float: 'right' }}
                                                    disabled={isLoading}
                                                    onClick={this.handleUpdateAll(x)}>
                                                    {getText("OfferUpdateAll")}
                                                </button>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", alignItems: 'center' }}>
                                            <input
                                                type="checkbox"
                                                className="offer-checkbox"
                                                style={{ flex: "0 0 auto", margin: 0 }}
                                                disabled={isLoading}
                                                onChange={this.handleCheckboxChange(x)}
                                            />
                                            <div style={{ flex: "1", marginLeft: 5 }}>
                                                <Select
                                                    options={priceOptions}
                                                    disabled={isLoading}
                                                    value={this.props.promotionDefaultPriceNameId[x.promotionId]}
                                                    onChange={(value) => this.props.updatePromotionDefaultPriceNameId(value, x.promotionId)}
                                                    style={{ background: bgColor }}
                                                />
                                            </div>
                                            <div style={{ flex: "0 0 auto", marginLeft: 5, marginRight: 2 }}>
                                                <DatePicker
                                                    value={this.props.promotionDate}
                                                    className="form-control input-sm"
                                                    disabled={isLoading}
                                                    minDate={Moment().startOf("day").toDate()}
                                                    dateFormat={'dd DD/MM/YYYY'}
                                                    showTimeSelect={true}
                                                    style={{ width: 115 }}
                                                    onChange={(newDate) => this.props.updatePromotionDate(newDate)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Selectors
const availableProductsSelector = createSelector(
    [(state: ApplicationState) => StockStore.availableProductsSelector(state)],
    (products) => [
        { label: "------", value: undefined },
        ...products.map(elt => ({
            label: elt.name,
            value: elt.storeItemId
        }))
    ]
);

const mapStateToProps = (state: ApplicationState) => ({
    promotions: state.seed.seed.promotions,
    priceNames: state.seed.seed.priceNames,
    availableProducts: availableProductsSelector(state),
    itemOfferResult: state.offer.itemOfferResult,
    itemOfferStates: state.offer.itemOfferStates,
    disabled: !canUpdate(state),
    itemOfTheDayState: state.offer.itemOfTheDayState,
    promotionDate: state.offer.promotionDate,
    promotionDefaultPriceNameId: state.offer.promotionDefaultPriceNameId,
    isNewDateSelected: state.offer.isNewDateSelected,
    products: OfferStore.productPromoFilteredSelector(state)
});

const mapDispatchToProps = {
    requestUpdateItemOfTheDay: OfferStore.actionCreators.requestUpdateItemOfTheDay,
    updateNewDateSelected: OfferStore.actionCreators.updateNewDateSelected,
    updateItemPromotionOffer: OfferStore.actionCreators.updateItemPromotionOffer,
    requestUpdateItemPromotion: OfferStore.actionCreators.requestUpdateItemPromotion,
    updateCheckedItemOffer: OfferStore.actionCreators.updateCheckedItemOffer,
    requestCreateItemPromotion: OfferStore.actionCreators.requestCreateItemPromotion,
    requestDeleteItemOffer: OfferStore.actionCreators.requestDeleteItemOffer,
    resetItemOfferState: OfferStore.actionCreators.resetItemOfferState,
    updateDateEndItemOffer: OfferStore.actionCreators.updateDateEndItemOffer,
    updatePromotionDefaultPriceNameId: OfferStore.actionCreators.updatePromotionDefaultPriceNameId,
    updatePromotionDate: OfferStore.actionCreators.updatePromotionDate
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferPromotions);